<script>
  import axios from "axios";
  import {} from "os";
  import u from "./utilities";
  import Spinner from './Spinner.svelte';
  import Logentries from './Logentries.svelte';

  import {licenceDate, setTime, licenceUrl, getBaseUrl, testGuest, logentriesUrl, sortByDate, buildLicenseData} from './app';

  let typeData = [];
  let licenceData = [];
  let logentries = [];

  let loading = 1;
  let loggedIn = jQuery('.logout-area').length;

  let date, time, select, remarks, selectLicence, fishname;
  export let message;
  const baseUrl = getBaseUrl();
  let getUrl = baseUrl + "/LicenseProductUsageLog?operation=getusagetypes";
  let success = 0;
  // https://shop.fischerparadies.ch/LicenseProductUsageLog?operation=getlicenseproducts
  let getLicenceUrl = baseUrl + "/LicenseProductUsageLog?operation=getlicenseproducts";
  let query = location.search;
  //console.log(query);
  const getLogEntries = u.updateQuerystring(baseUrl + "/LicenseProductUsageLog?operation=getlogentriesforcurrentuser");
  const today = u.today();
  let endDate = u.formatDate(today);
  let startDate = '';
  let hasDate = false;
  let ok = 1;
  let online = 1;
  let trouts = [];
  let dailylimit = 5;

  let dailyCiscoLimit = 15;
  let ciscos = [];

  let licenceType = "adult";
  let licenceDuration = "day";
  let disable = 0;
  let trouttypecheck = 0;
  let weeklylimit = {
    "adult": 30,
    "young": 25
  };
  let monthlylimit = {
    "adult": 40,
    "young": 30
  };
  let yearlyLimit = {
    "small": 50,
    "large": 80,
  };
  let productNr = null;
  let relatedProductTrouts = [];
  let relatedProductCiscos = [];
  //let totalTrouts = 0;
  let thisYear = today.getFullYear();
  // //console.log(u.formatDate(today));
  let generalCloseSeason = u.getDateArray(new Date(thisYear + "-12-01"), new Date(thisYear + "-12-25"));
  let troutCloseSeason = u.getDateArray(new Date(thisYear + "-10-01"), new Date(thisYear + "-12-25"));
  let ciscoCloseSeason = u.getDateArray(new Date(thisYear + "-01-01"), new Date(thisYear + "-01-15")).concat(u.getDateArray(new Date(thisYear + "-11-01"), new Date(thisYear + "-12-31")));
  ////console.log(ciscoCloseSeason);
  let ciscoCScheck = ciscoCloseSeason.indexOf(u.formatDate(today)) > -1 ? true : false;
  let troutCScheck = troutCloseSeason.indexOf(u.formatDate(today)) > -1 ? true : false;
  let generalCScheck = generalCloseSeason.indexOf(u.formatDate(today)) > -1 ? true : false;


  $: dailytrout = relatedProductTrouts.length ? dailyTroutsCalculation() : dailylimit;
  $: dailycisco = relatedProductCiscos.length ? dailyCiscoCalculation() : dailyCiscoLimit;
  $: showedLogentries = productNr ? logentries.filter(o => {
    return o.RelatedOrdersProductsID == productNr;
  }) : logentries;
  $: showedTypeData = dailycisco >= dailyCiscoLimit ?  builTypeData(typeData) : builTypeData(typeData);
  $: licenceName = productNr !== null || productNr !== -1 ? u.getLicenceName(licenceData, productNr) : '';
  $: remaining = getRemaining(logentries);
  $: ownerdetails = productNr !== null || productNr !== -1 ? u.getLicenceOwnerDetails(licenceData, productNr) : null;

  // console.log("relatedProductTrouts", relatedProductTrouts);
  // console.log("dailytrout", dailytrout);
  // console.log("remaining", remaining);
  // console.log("dailycisco", dailycisco);
  // console.log("relatedProductCiscos", relatedProductCiscos)

  function getRemaining(entries) {
    let out = {
        total: 0,
        catch: 0
      };
    if (licenceName) {
      out.total = dailylimit;
      let duration = u.getlicenceDuration(licenceName);
      let type = u.getLicenceType(licenceName);
      let rt = filterPatentTrouts(entries);
      out.catch = rt.length;
      if (duration === "week") {
        out.total = weeklylimit[type]
      }
      if (duration === "month") {
        out.total = monthlylimit[type];
      }
      if (duration.indexOf("year") > -1) {
        out.total = yearlyLimit[duration.replace("year-", "")];
      }
    }
    return out;
  }
  function filterPatentTrouts(entries) {
    return entries.filter((e) => {
      return e.TypeDisplayName.toLowerCase().includes("forelle") && e.RelatedOrdersProductsID === productNr;
    })
  }

  //start app
  Promise.all([axios.get(u.updateQuerystring(getUrl)), axios.get(u.updateQuerystring(licenceUrl(getLicenceUrl, query)))]).then(response => {

    loading = 0;
    //console.log(loading);
    typeData = response[0].data.Data;
    showedTypeData = typeData;
    licenceData = buildLicenseData(response[1].data.Data);
    // console.log(licenceData);
    if (licenceData.length === 1) {
      selectLicence = licenceData[0];
      productNr = licenceData[0].RelatedOrdersProductsID;
      getLogEntriesOfCurrentUser(selectLicence);
      onLicenceChange();
    } else {
      getLogEntriesOfCurrentUser();
    }

  });

  function builTypeData(td) {
    let temp = td;
    if (troutCScheck) {
      temp = temp.filter(d => {
        let typename = d.TypeDisplayName.toLowerCase();
        return typename !== "seeforelle" && typename !== "bachforelle";
      });
    }
    //console.log("type data dailycisco", dailycisco);
    if (dailycisco <= 0) {
      temp = temp.filter(d => {
        return d.TypeDisplayName.toLowerCase() !== "felchen";
      });
    }
    if (ciscoCScheck) {
    temp = temp.filter(d => {
      return d.TypeDisplayName.toLowerCase() !== "felchen";
    });
    }
    return temp;
  }

  function dailyCiscoCalculation(rel) {
    let rpc = typeof rel === "undefined" ? relatedProductCiscos : rel;
    let out = dailyCiscoLimit;
    // let count = rpc.length;
    // console.log("rpx<", count)
    let dc = u.dailyItemCount(rpc);
    out = dailyCiscoLimit - dc.length;
    // if (count >= dailyCiscoLimit) out = 0;
    //
    return out;
  }

  function dailyTroutsCalculation(rel) {
    //console.log(rel)
    let rpt = typeof rel === "undefined" ? relatedProductTrouts : rel;
    let out = dailylimit;
    // if (relatedProductTrouts.length) {
    let count = rpt.length;
    let dt = u.dailyItemCount(rpt);
    //console.log(dt)
    out = dailylimit - dt.length;
    licenceDuration = u.getlicenceDuration(licenceName);
    licenceType = u.getLicenceType(licenceName);
    console.log(licenceType, licenceDuration)
    if (licenceDuration == "week") {
      ////console.log("is week");
      let wl = weeklylimit[licenceType];
      //console.log(wl);
      if (count >= wl) {
        out = 0;
      } else if (wl - count < dailylimit) {
        out = wl - count;
      }
    }
    if (licenceDuration == "month") {
      let ml = monthlylimit[licenceType];
      if (count >= ml) {
        out = 0;
      } else if (ml - count < dailylimit) {
        out = ml - count;
      }
    }
    // yearly limit => indexOf method just in case there is an IE 11 (hopefully not!)
    if (licenceDuration.indexOf("year") > -1) {
      let yl = yearlyLimit[licenceDuration.replace("year-", "")];
      if (count >= yl) {
        out = 0;
      } else if (yl - count < dailylimit) {
        out = yl - count;
      }
    }
    // }
    // //console.log(out);
    return out;
  }


  function doCheck(l) {

    let log = typeof l === "undefined" ? logentries : l;
    trouts = u.checkTrout(log);
    let dt = u.dailyItemCount(trouts);
    licenceDuration = u.getlicenceDuration(licenceName);
    licenceType = u.getLicenceType(licenceName);
    relatedProductTrouts = u.checkRelatedProductItems(trouts, productNr);
    ciscos = u.checkCisco(log);
    //console.log("doCheck ciscos", ciscos);
    relatedProductCiscos =  u.checkRelatedProductItems(ciscos, productNr);
    //console.log("do check relatedProductCiscos", relatedProductCiscos);
    let dc = u.dailyItemCount(ciscos);
    //console.log("do check dailyItemCount", dc);
    dailycisco = dailyCiscoLimit - dc.length;
    // console.log("dailycisco", dailycisco)
    // console.log("dailytrout", dailytrout);
    return [dt, dc];
  }

  async function getLogEntriesOfCurrentUser(obj) {

    productNr = typeof obj === "undefined" ? null : obj.RelatedOrdersProductsID;
    let url = u.updateQuerystring(logentriesUrl(getLogEntries));
    axios.get(url).then(res => {
      if (res.data.hasOwnProperty("Data") && res.data.Data.length) {
        logentries = sortByDate(res.data.Data);
      }
      if (productNr) {
        doCheck();
      }
    }).catch(error => {
      console.log(error);
      message = error;
    });
  }




  // send new entry
  async function senddata(e) {
    let m = [];
    let valid = 1;
    // let check = 0;
    let fishname = select == "" ? null : select.TypeDisplayName;
    message = '';
    //console.log(select);
    let userData = await axios.get(u.updateQuerystring(logentriesUrl(getLogEntries)));
    disable = 1;
    try {

      let t = u.dailyItemCount(u.checkTrout(u.checkRelatedProductItems(userData.data.Data, productNr)));
      let c = u.dailyItemCount(u.checkCisco(u.checkRelatedProductItems(userData.data.Data, productNr)));
      // daily trout calculation
      let dt = dailyTroutsCalculation(t);
      let dc = dailyCiscoCalculation(c);

      if (date == undefined) {
        m.push(`Bitte geben Sie ein gültiges Datum ein!`);
        valid = 0;
      }
      // if (time == undefined) {
      //   m.push(`Bitte geben Sie eine Zeit ein!`);
      //   valid = 0;
      // }
      if (!fishname) {
        m.push(`Bitte wählen Sie eine Fischart`);
        valid = 0;
        disable = 0;
      }
      if (dt !== dailytrout) {
        dailytrout = dt;
        if (dt == 0) {
          valid = 0;
          m.push(`Sie haben in der Zwischenzeit Ihr Tageslimit an Forellen erreicht (vielleicht haben Sie mehrere Browserfenster geöffnet) - laut Reglement dürfen Sie nun nicht mehr weiterfischen!`);
          disable = 0;
        }
      }
      if (dc !== dailycisco) {
        dailycisco = dc;
        if (dc == 0) {
            valid = 0;
            disable = 0;
            m.push(`Sie haben in der Zwischenzeit Ihr Tageslimit an Felchen erreicht (vielleicht haben Sie mehrere Browserfenster geöffnet)`);
        }
      }
      message = m.join("<br>");
      if (valid) {
        time = setTime();
        let rm = remarks ? "&RemarksByCustomer=" + encodeURIComponent(remarks) : '';
        let ids = "&RelatedOrderID=" + selectLicence.RelatedOrderID + "&RelatedOrdersProductsID=" + selectLicence.RelatedOrdersProductsID;
        let postUrl = u.updateQuerystring(baseUrl + '/LicenseProductUsageLog?operation=insert&typeid=' + select.ID + '&TypeDisplayName=' + encodeURIComponent(fishname) + '&usedon=' + encodeURIComponent(date + ' ' + time) + ids + rm);
        //console.log(postUrl);
        let update = await axios.post(postUrl);
        try {
          //console.log(update.data);
          disable = 0;
          success = 1;
          time = '';
          select = '';
          //selectLicence = '';
          hasDate = false;
          remarks = '';
          message = "Fang erfolgreich eingetragen.";
          //response.data.Message + " Guid: " + response.data.Guid;
          getLogEntriesOfCurrentUser(selectLicence);
          setTimeout(() => {
            hasDate = true;
            message = '';
          }, 1000);
        } catch (e) {
          //console.log(e);
          message = e;
        }
      }

    } catch (e) {
      console.log(e)
    }

  }

  // licence change options
  function onLicenceChange(event) {
    //console.log(selectLicence);
    startDate = '';
    endDate = '';
    date = '';
    message = '';
    let year = 0;
    if (selectLicence != '') {
      hasDate = true;
      ok = 1;
      year = selectLicence.SeasonStartDate ? 1 : 0;
      let start = selectLicence.SeasonStartDate ? selectLicence.SeasonStartDate === '2024-01-01T00:00:00' ? '2023-12-26T00:00:00' : selectLicence.SeasonStartDate : selectLicence.StartDate;
      let end = selectLicence.EndDate ? selectLicence.EndDate : start;
      if (year) {
        end = new Date(new Date(start).getFullYear(), 11, 31);
      }
      console.log(end)
      console.log(today)
      console.log('end', end);
      if (new Date(end) > today) end = today;
      startDate = u.formatDate(start);
      console.log('startdate', startDate);
      endDate = u.formatDate(end);
      // only fischerparadies
      date = u.formatDate(today);
      // date = startDate;
      time = setTime();
      ////console.log(time);
      if (new Date(startDate) > today) ok = 0;
      if (u.testForOnline(selectLicence.ProductName)) {
        online = 1;
        //console.log("getLogEntriesOfCurrentUser in onSelectChange");
        getLogEntriesOfCurrentUser(selectLicence);
      } else {
        online = 0;
        productNr = -1;
      }
    } else {
      hasDate = false;
      productNr = null;
      remaining.total = 0;
    }
  }

  function onTypeChange() {
    fishname = select == "" ? null : select.TypeDisplayName;
    //console.log(fishname);
    trouttypecheck = 0;
    if (fishname.toLowerCase() === "seeforelle") {
      trouttypecheck = 1;
    }
    if (fishname.toLowerCase() === "bachforelle") {
      trouttypecheck = 1;
    }
  }

  function confirm() {
    trouttypecheck = 0;
  }

</script>

<div class="app-form">
  {#if loading}
    <Spinner message="Lade Applikation" />
  {:else}
  {#if generalCScheck }
    <div class="general-close-season">
      <strong>Generelle Schonzeit und Betriebsferien 1. - 25. Dezember</strong>
    </div>
  {:else}
  {#if licenceData.length == 0}
    {#if !loggedIn} 
    <div class="alert error"><a href="{baseUrl}/App/Login.aspx?c1=583" style="text-decoration:underline">Loggen Sie sich ein</a>, um Einträge zu erfassen. </div>
    {:else}
    <div class="alert error">Sie verfügen aktuell über kein gültiges Patent. Bitte lösen Sie eines hier im Online Shop.</div>
    {/if}
  {/if}
  {#if typeData.length && licenceData.length}
  <div class="form-group">
    <label for="licence">Patente</label>
    <!-- svelte-ignore a11y-no-onchange -->
    <select id="licence" name="licence" bind:value={selectLicence} on:change={onLicenceChange}>
      <option value="">--</option>
      {#each licenceData as licence}
        <option value={licence}>{licence.ProductName} für {licence.BillingFirstName} {licence.BillingLastName}, {licenceDate(licence)}</option>
      {/each}
    </select>
  </div>
  {#if ownerdetails &&  remaining.total}
  <div class="licence-informations">

    <span class="title">Patentangaben</span>
    {#if ownerdetails}
  <div class="owner-details">
    <span class="firstname row">
     <span class="label">Bestellnummer</span>
      <span class="value">{ ownerdetails.ordernumber }</span>
    </span>
    <span class="firstname row">
     <span class="label">Vorname</span>
      <span class="value">{ ownerdetails.firstname }</span>
    </span>
    <span class="name row">
      <span class="label">Name</span>
      <span class="value">{ ownerdetails.name }</span>
      </span>
      <span class="dob row">
        <span class="label">Geburtsdatum</span>
        <span class="value">{ ownerdetails.dob }</span>
      </span>
      {#if ownerdetails.guestcard != undefined }

      <span class="dob row">
        <span class="label">Gästekarte</span>
        <span class="value">{ ownerdetails.guestcard === true ? 'ja' : 'nein' }</span>
      </span>
      {/if}

  </div>
  {/if}

<div class="infos">
  <div class="trout-amount">
    {#if dailytrout > 0}
    <span class='yes'>Sie können heute noch <strong>{dailytrout}</strong> Forellen eintragen.</span>
    {:else}
    <span class="no error">Mit dem Erreichen des Tageslimits von {dailylimit} Forellen,  können laut Reglement keine weiteren Fische mehr eingetragen werden.</span>
    {/if}
    </div>
    {#if dailycisco <= 0}
      <div class="cisco-limit error">Die Tageslimite gefischer Felchen ist erreicht.</div>
    {/if}

    <div class="limits">
    {#if remaining.total}
    <h2>Limiten Forellen</h2>
    <div class="remaining">
     <p class="row"><span class="label">Limite für dieses Patent:</span> <strong class="value">{remaining.total}</strong></p>
     <p class="row"><span class="label">Total gefangene Forellen für dieses Patent:</span><strong class="value">{remaining.catch}</strong></p>
     <p class="row"><span class="label">Verbleibende Forellen:</span><strong class="value">{remaining.total - remaining.catch}</strong></p>
    </div>
    {/if}
    <h2>Limiten Felchen</h2>
    <div class="cisco-section">
      <p class="row"><span class="label">Tageslimite für Felchen:</span> <strong class="value">{dailyCiscoLimit}</strong></p>
      <p class="row"><span class="label">Verbleibende Felchen:</span><strong class="value">{dailycisco}</strong>  </p>

  </div>
  </div>

</div>


  </div>
  {/if}

  {#if hasDate}
    {#if ok}
    {#if online}
  <div class="form-group date">
    <label for="date">Datum</label>
    <!-- <input id="date" name="date" type="date" bind:value={date} min={startDate}  max={endDate}> -->
    <input id="date" name="date" type="date" bind:value={date} disabled>
  </div>
  <!-- <input id="time" name="time" type="time" bind:value={time}> -->
  <!-- <div class="form-group time">
    <label for="time">Zeit</label>

    <input id="time" name="time" type="time" bind:value={time} disabled>
  </div> -->

  <div class="form-group form-select type">
    <div class="close-season">
      {#if troutCScheck}
      <span class="trout-close-season">Bach- und Seeforellen Schonzeit 1.Oktober - 25. Dezember</span>
    {/if}
    {#if ciscoCScheck}
    <span class="cisco-close-season">Felchen Schonzeit 1.November - 15. Januar</span>
    {/if}
    </div>
    <!-- <div class="trout-amount">
      {#if dailytrout > 0}
      <span class='yes'>Sie können heute noch <strong>{dailytrout}</strong>  {#if !troutCScheck} Bach-, See- oder {/if}Regenbogenforellen eintragen.</span>
      {:else}
      <span class="no error">Mit dem Erreichen des Tageslimits von {dailylimit} Forellen,  können laut Reglement keine weiteren Fische mehr eingetragen werden.</span>
      {/if}

    </div> -->
    {#if dailytrout > 0}
    <label for="type">Fischart</label>
    <select id="type" bind:value={select} on:change={onTypeChange}>
      <option value="">--</option>
      {#each showedTypeData as type}
        <option value={type}>{type.TypeDisplayName}</option>
      {/each}
    </select>
    {/if}
  </div>
  {#if trouttypecheck == 1}
    <div class="trout-type alert">
      <p>Sie haben <em>{fishname}</em> angewählt - {fishname} wird gerne mit Regenbogenforelle verwechselt.<br>
      Bitte bestätigen Sie Ihre Wahl oder ändern Sie die Auswahlliste.</p>
      <button type="button" class="button" on:click={confirm}>Bestätigen</button>
    </div>
  {:else}
    {#if dailytrout > 0}
    <div class="form-group remarks">
      <label for="remarks">Anmerkungen</label>
      <textarea name="remarks" cols="30" rows="5" bind:value={remarks}></textarea>
    </div>
    <div class="form-group has-button">
      <button type="button" class="button submit-button {disable?'disabled': ''}" on:click={senddata}>eintragen</button>
    </div>
    {/if}
  {/if}
  <!-- online -->
  {:else}
  <div class="message error">Bei einem Patent mit Papierstatistik können keine Fänge online eingetragen werden.</div>
  {/if}
  <!-- ok -->
  {:else}
    <div class="message error">Es können keine Einträge in der Zukunft eingetragen werden.</div>
  {/if}
  {/if}
  {#if message.length}
    <div class="message { success == 1 ? 'success' : 'error' }">{@html message}</div>
  {/if}
  {/if}

  {#if showedLogentries.length}

  <Logentries number={productNr} name={licenceName} entries={showedLogentries} />

  {:else}
  <div class="message no-entries">
    Für diesen Benutzer sind noch keine Einträge erfasst.
  </div>
  {/if}
  {/if}
{/if}
</div>

<style>

  .remaining {
    margin:  0;
    font-size: 0.9125rem;
    display: table;
  }
  .remaining p{
    margin: 0;
  }

  .owner-details {
    font-size: 0.9125rem;
    padding:  0;
    display: table;
    margin-bottom: 10px
  }
  .cisco-section {
    display: table;
    font-size: 0.9125rem;
    padding:  0;
    display: table;
    margin-bottom: 20px

  }
  .owner-details .row,
  .remaining .row,
  .cisco-section .row {
    display: table-row;
  }
  .owner-details .label,
  .remaining .label,
  .owner-details .value,
  .remaining .value,
  .cisco-section .label,
  .cisco-section .value {
    display: table-cell;
    padding: 0 10px 0 0;
  }
  .remaining .value {
    text-align: right;
  }

.licence-informations {
  margin: 20px 0;
}
 .title {
    font-size: 0.9125rem;
    font-weight: bold;
  }
 .limits h2 {
   font-size: 0.9125rem;
   margin: 16px 0 0;
 }
 .cisco-limit {
  border: 1px dotted #bb0912;
  padding: 10px;
  margin: 10px 0;
  color: #bb0912;
 }
</style>